import React from 'react';
import Navbar from './Components/Navbar';
import { BrowserRouter as Router } from 'react-router-dom';  //this coz when we did link in navbar it gave error so we did down 2 <Router>
import Hero from './Components/Hero';
import Sidebar from './Components/Sidebar';
import Cakes from './Components/Cakes';
import Favorite from './Components/Favorite';
import Chefs from './Components/Chefs';
import ContactUs from './Components/ContactUs';
import Footer from './Components/Footer';




function App() {
  return (

    // <Router>
    // <div>
    //  <Navbar />
    //   <Hero />
    //   <Sidebar />
    //   <Cakes />
    //   <CakesCards />
    // </div>
    // </Router>

     <Router >
      <Navbar />
      <Hero />
      {/* <Sidebar /> */}
      {/* <Cakes id='menu'></Cakes> */}
      <Cakes id='menu' />
      <Favorite />
      <Chefs />
      <ContactUs />
      <Footer />
      
     </Router>

     



  )
}

export default App;
